export default {
    about: 'About',
    legalMention: 'Legal Mentions',
    blog: 'Blog',
    privacyPolicy: 'Privacy Policy',
    cgu: 'Terms of use',
};
